// Check if it is correct

import { portuguesVersion, germanVersion, brasilianVersion } from './testPlan'
// import testImmunizations from './testImmunizationGQL'
import {
  brasilianRecommendations1Year,
  germanRecommendations5Years,
  portuguesRecommendations1Year
} from './testRecommendations'
import {
  portuguesImmunizationsBefore1Year,
  germanImmunizations,
  brasilianImmunizationsBefore1Year
} from './testImmunizationGQL'
import moment from 'moment'

// 2018-10-10T17:35:31.746369+01:00
const today = moment()
const birthPT = moment().year(today.get('year') - 1).toString()
const birthDE = moment().year(today.get('year') - 5).toString()
const patients = [
  {
    id: '123',
    name: 'Paulo Miguel BR',
    photo: 'https://cdn.kenetto.com/vaccinapp/imgs/babyMale.png',
    birthDate: birthPT,
    gender: 'male',
    immunizations: brasilianImmunizationsBefore1Year,
    plan: brasilianVersion,
    recommendations: brasilianRecommendations1Year
  },
  {
    id: '1234',
    name: 'Joana Silva PT',
    photo: 'https://cdn.kenetto.com/vaccinapp/imgs/babyFemale.png',
    birthDate: birthPT,
    gender: 'male',
    immunizations: portuguesImmunizationsBefore1Year,
    plan: portuguesVersion,
    recommendations: portuguesRecommendations1Year
  },
  {
    id: '12345',
    name: 'Robert Koch DE',
    birthDate: birthDE,
    gender: 'male',
    photo: 'https://cdn.kenetto.com/vaccinapp/imgs/childMale.png',
    immunizations: germanImmunizations,
    plan: germanVersion,
    recommendations: germanRecommendations5Years
  }
]
export default patients
